import React from 'react';
import { AntTableCell, AntTableCellFilter } from '../../../../../../theme/Table';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@mui/material';
import TableFilter from '../../../../../../components/global/table/TableFilter';
import dateFormat from 'dateformat';
import TableSort from '../../../../../../components/global/table/TableSort';
import TableNoDataComponent from '../../../../../../components/global/table/TableNoData';

const TableACLs = ({
  data,
  setFilter,
  filter,
  sortActive,
  setSortActive,
  customTrim,
}) => {
  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <AntTableCell>
              <TableSort
                name="sortId"
                direction={filter?.sort?.sortId}
                label="ID"
                setFilter={setFilter}
                sortActive={sortActive}
                setSortActive={setSortActive}
                filter={filter}
                type={'FILTER_ACTIVE'}
              />
            </AntTableCell>
            <AntTableCell>ACL name</AntTableCell>
            <AntTableCell>IP addresses </AntTableCell>
            <AntTableCell>Related zones</AntTableCell>
            <AntTableCell>Updated at</AntTableCell>
            <AntTableCell>Created at</AntTableCell>
          </TableRow>
          <TableRow>
            <AntTableCellFilter>
              <TableFilter
                name="id"
                setFilter={setFilter}
                filter={filter}
                type={'FILTER_ACTIVE'}
              />
            </AntTableCellFilter>
            <AntTableCellFilter>
              <TableFilter
                name="name"
                setFilter={setFilter}
                filter={filter}
                type={'FILTER_ACTIVE'}
              />
            </AntTableCellFilter>
          </TableRow>
        </TableHead>
        <TableBody>
          {data && data?.dnsAcls?.items.length !== 0 ? (
            data?.dnsAcls?.items?.map(
              ({
                id,
                name,
                address,
                dnsResources,
                updatedAt,
                createdAt,
              }) => (
                <TableRow hover key={id}>
                  <AntTableCell component="th" scope="row">
                    {id}
                  </AntTableCell>
                  <AntTableCell>{customTrim(name, 17)}</AntTableCell>
                  <AntTableCell>{customTrim(address, 60)}</AntTableCell>
                  <AntTableCell>{customTrim(dnsResources.zone, 60)}</AntTableCell>
                  <AntTableCell>{dateFormat(updatedAt, 'dd/mm/yy hh:MM:ssTT')}</AntTableCell>
                  <AntTableCell>{dateFormat(createdAt, 'dd/mm/yy hh:MM:ssTT')}</AntTableCell>
                </TableRow>
              )
            )
          ) : (
            <TableNoDataComponent colSpan={6} />
          )}
        </TableBody>
      </Table>
    </>
  );
};
export default TableACLs;
